import { Position } from '@xyflow/react'

function getParams (nodeA, nodeB) {
  const centerA = getNodeCenter(nodeA)
  const centerB = getNodeCenter(nodeB)

  const horizontalDiff = Math.abs(centerA.x - centerB.x)
  const verticalDiff = Math.abs(centerA.y - centerB.y)

  let position
  if (horizontalDiff > verticalDiff) {
    position = centerA.x > centerB.x ? Position.Left : Position.Right
  } else {
    position = centerA.y > centerB.y ? Position.Top : Position.Bottom
  }

  const [x, y] = getHandleCoordsByPosition(nodeA, position)
  return [x, y, position]
}

export function getHandleCoordsByPosition (node, handlePosition) {
  const handle = node.internals.handleBounds.source.find(
    (h) => h.position === handlePosition
  ) ?? node.internals.handleBounds.source?.[0]

  if (!handle) {
    return [0, 0]
  }

  let offsetX = handle.width / 2
  let offsetY = handle.height / 2

  switch (handlePosition) {
    case Position.Left:
      offsetX = 0
      break
    case Position.Right:
      offsetX = handle.width
      break
    case Position.Top:
      offsetY = 0
      break
    case Position.Bottom:
      offsetY = handle.height
      break
    default:
      offsetY = 0
      offsetX = 0
  }

  const x = node.internals.positionAbsolute.x + handle.x + offsetX
  const y = node.internals.positionAbsolute.y + handle.y + offsetY

  return [x, y]
}

export function getHandleCoordsById (node, positionId, handleType = 'target') {
  const handle = node.internals.handleBounds[handleType].find(
    (h) => h.id === positionId
  )

  if (!handle) {
    return
  }

  let offsetX = handle.width / 2
  let offsetY = handle.height / 2

  switch (handle.position) {
    case Position.Left:
      offsetX = 0
      break
    case Position.Right:
      offsetX = handle.width
      break
    case Position.Top:
      offsetY = 0
      break
    case Position.Bottom:
      offsetY = handle.height
      break
    default:
      offsetY = 0
      offsetX = 0
  }

  const x = node.internals.positionAbsolute.x + handle.x + offsetX
  const y = node.internals.positionAbsolute.y + handle.y + offsetY

  return [x, y]
}

function getNodeCenter (node) {
  return {
    x: node.internals.positionAbsolute.x + node.measured.width / 2,
    y: node.internals.positionAbsolute.y + node.measured.height / 2
  }
}

export function getEdgeParams (source, target) {
  const [sx, sy, sourcePos] = getParams(source, target)
  const [tx, ty, targetPos] = getParams(target, source)

  return {
    sx,
    sy,
    tx,
    ty,
    sourcePos,
    targetPos
  }
}
